import React from 'react';

export default function NoFound() {
  return (
    <div className="w-full py-10 text-center">
      <p className="text-primary text-lg sm:text-xl font-semibold">
        Add a new record to get started.
      </p>
    </div>
  );
}
